import React from "react"
import PropTypes from 'prop-types'
import SelectMultiGenericNew from "../../../../../../gd-ui/select-multi-generic-new/select-multi-generic-new";
import FieldStatus_MultiselectValueNotEmpty from "../../../../../generic/status/components/multiselect/value-not-empty";
import FieldStatus_MultiselectPopoverOption from "../../../../../generic/status/components/multiselect/option";


export default class FieldTaskStatus_AutomationTriggerForm extends React.Component<any> {

    static propTypes = {
        config          : PropTypes.object,
        // options         : PropTypes.array,
        onChangeCallback: PropTypes.func,
    }

    onChangeFromValues    = (fromValues:any)    => this.props.onChangeCallback({fromValues})
    onChangeToValues      = (toValues:any)      => this.props.onChangeCallback({toValues})

    render() {

        const options = gd.session.statuses.toOptions()

        return (
            <div className="flex-row-left-top">
                <div className="label">from</div>
                <SelectMultiGenericNew className                        = "selector w-180"
                                       options                          = {options}
                                       values                           = {this.props.config.fromValues}
                                       allValuesOptionLabel             = "Any"
                                       popoverScrollContainerClasses    = "max-h-200 max-w-200"
                                       allValuesOption                  = {true}
                                       isSearchable                     = {true}
                                       valueComponent                   = {FieldStatus_MultiselectValueNotEmpty}
                                       popoverOptionComponent           = {FieldStatus_MultiselectPopoverOption}
                                       disabled                         = {this.props.config.disabled}
                                       onChange                         = {this.onChangeFromValues}/>

                <div className="label">to</div>
                <SelectMultiGenericNew className                        = "selector w-180"
                                       options                          = {options}
                                       values                           = {this.props.config.toValues}
                                       allValuesOptionLabel             = "Any"
                                       popoverScrollContainerClasses    = "max-h-200 max-w-200"
                                       allValuesOption                  = {true}
                                       isSearchable                     = {true}
                                       valueComponent                   = {FieldStatus_MultiselectValueNotEmpty}
                                       popoverOptionComponent           = {FieldStatus_MultiselectPopoverOption}
                                       disabled                         = {this.props.config.disabled}
                                       onChange                         = {this.onChangeToValues}/>
            </div>
        )
    }



    // static propTypes = {
    //     config          : PropTypes.object,
    //
    //     // options         : PropTypes.array,
    //
    //     onChangeCallback: PropTypes.func,
    // }
    //
    // onChangeFromValues    = (fromValues:any)    => this.props.onChangeCallback({fromValues})
    // onChangeToValues      = (toValues:any)      => this.props.onChangeCallback({toValues})
    //
    // render() {
    //
    //     const options = this.props.field.options
    //
    //     return (
    //         <div className="flex-row-left-top">
    //             <div className="label">from</div>
    //             <SelectMultiGenericNew className                        = "selector w-180"
    //                                    // options                          = {this.props.options}
    //                                    options                          = {this.props.field.getOptions()}
    //                                    values                           = {this.props.config.fromValues}
    //                                    allValuesOptionLabel             = "Any"
    //                                    popoverScrollContainerClasses    = "max-h-200 max-w-200"
    //                                    allValuesOption                  = {true}
    //                                    isSearchable                     = {true}
    //                                    valueComponent                   = {PriorityMultiselectValueNotEmpty}
    //                                    popoverOptionComponent           = {PriorityMultiselectPopoverOption}
    //                                    disabled                         = {this.props.config.disabled}
    //                                    onChange                         = {this.onChangeFromValues}/>
    //
    //             <div className="label">to</div>
    //             <SelectMultiGenericNew className                        = "selector w-180"
    //                                    // options                          = {this.props.options}
    //                                    options                          = {this.props.field.getOptions()}
    //                                    values                           = {this.props.config.toValues}
    //                                    allValuesOptionLabel             = "Any"
    //                                    popoverScrollContainerClasses    = "max-h-200 max-w-200"
    //                                    allValuesOption                  = {true}
    //                                    isSearchable                     = {true}
    //                                    valueComponent                   = {PriorityMultiselectValueNotEmpty}
    //                                    popoverOptionComponent           = {PriorityMultiselectPopoverOption}
    //                                    disabled                         = {this.props.config.disabled}
    //                                    onChange                         = {this.onChangeToValues}/>
    //         </div>
    //     )
    // }
}